import { ErrorBoundary } from '@components/Fillers/ErrorBoundary'
import { FallbackSeo } from '@components/SEO/FallbackSeo'
import { NavigationBar } from '@features/web-navigation/components/NavigationBar'
import PopoverNav from '@features/web-navigation/components/PopoverNav'
import { useNav } from '@features/web-navigation/hooks/useNav'
import { NavProvider } from '@features/web-navigation/provider'
import { useShortcuts } from '@lib/utils/useShortcuts'
import * as Colors from '@themes/Colors'
import Head from 'next/head'
import * as React from 'react'
import { StyleSheet, View } from 'react-native'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { AuthProvider } from '~/features/auth/components/AuthProvider'
import { IntercomProvider } from '~/features/intercom/IntercomProvider'
import { IntercomWrapper } from '~/features/intercom/IntercomWrapper'
import { ClerkRefresh } from '~/Lib/Auth/clerk-refresh'
// import { useFlags } from '~/features/flags/context'

export function Layout({
  children,
  user,
}: React.PropsWithChildren<{ user?: any }>) {
  useShortcuts()

  return (
    <AuthProvider user={user}>
      <ClerkRefresh />
      <IntercomProvider>
        <IntercomWrapper>
          <NavProvider>
            <InnerLayout>{children}</InnerLayout>
          </NavProvider>
        </IntercomWrapper>
      </IntercomProvider>
    </AuthProvider>
  )
}

function InnerLayout({ children }: React.PropsWithChildren) {
  const { isLt768 } = useNav()
  // const { state } = useFlags()

  return (
    <>
      <FallbackSeo />
      <Head>
        <meta key="theme-color" name="theme-color" content={Colors.white} />
      </Head>

      <SafeAreaProvider>
        <View
          style={[
            styles.container,
            {},
            // !!state.blueDev && { alignItems: 'flex-end', paddingRight: 64 },
          ]}
        >
          <View style={isLt768 ? styles.frame : styles.frameGt425}>
            {isLt768 ? (
              <PopoverNav />
            ) : (
              <View style={styles.leftSide} testID="leftSide">
                <NavigationBar />
              </View>
            )}

            <View
              style={[styles.rightSide, !isLt768 && styles.contentBorder]}
              testID="rightSide"
            >
              <ErrorBoundary>{children}</ErrorBoundary>
            </View>
          </View>
        </View>
      </SafeAreaProvider>
    </>
  )
}

export const getLayout = function getLayout<T extends React.ReactNode>(
  page: T
) {
  return <Layout>{page}</Layout>
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    // height: '100%',
    // minHeight: '100vh',
    width: '100%',
    // overflow: 'hidden',
  },
  contentBorder: {
    borderColor: Colors.altWhite,
  },
  frame: {
    display: 'grid',
    gridTemplateColumns: '100vw',
    gridTemplateRows: '1fr',
    gridGap: '0px',
    // margin: '0 auto',
    margin: 0,
    height: '100%',
  },
  frameGt425: {
    display: 'grid',
    gridTemplateColumns: 'minmax(48px, 275px) minmax(377px, 600px)',
    gridTemplateRows: '1fr',
    gridGap: '0px',
    // margin: '0 auto',
    margin: 0,
    height: '100%',
    // overflow: 'hidden',
  },
  leftSide: {
    backgroundColor: Colors.white,
    overflow: 'hidden',
    minWidth: 48,
    maxWidth: 275,
  },
  rightSide: {
    backgroundColor: Colors.white,
    width: '100%',
    // height: '100%',
    minHeight: '100vh',
  },
})
